import * as mutations from "./mutation-types";
import api from "@/api";
import { config } from "@/constants/index";

export const transformTickets = (tickets = []) => {
  return tickets.map(ticket => transformTicket(ticket));
};

export const transformTicket = (ticket = {}) => {
  ticket.customerId = ticket.customer.id;
  ticket.ownerId = ticket.owner.id;
  ticket.ownerFullName = ticket.customer.fullName;
  ticket.partakers = [];
  ticket.isLegit = true;
  ticket.departingAirport = {};

  return ticket;
};

export const getTickets = async ({ commit }, id) => {
  const res = await api.ticket.all(id);

  commit(mutations.SET_CUSTOMER_TICKETS, {
    id,
    tickets: transformTickets(res.data["hydra:member"]),
  });

  return res;
};

export const getTicket = async ({ commit }, { customerId, id }) => {
  const res = await api.ticket.get(id);
  commit(mutations.ADD_CUSTOMER_TICKET, {
    customerId,
    ticket: transformTicket(res.data),
  });

  return res;
};

export const shareTicket = async ({ commit }, id) => {
  const res = await api.ticket.share(id);
  const ticket = res.data;
  commit(mutations.ADD_CUSTOMER_TICKET, {
    customerId: ticket.customerId,
    ticket,
  });

  return res;
};

export const unshareTicket = async ({ commit }, id) => {
  const res = await api.ticket.unshare(id);
  const ticket = res.data;
  commit(mutations.ADD_CUSTOMER_TICKET, {
    customerId: ticket.customerId,
    ticket,
  });

  return res;
};

export const shareTicketBenefits = async (context, id) => {
  return await api.ticket.shareBenefits(id);
};

export const getTicketHistoryPage = async ({ commit }, { id, page }) => {
  let res = await api.ticket.history(id, {
    page,
    maxPerPage: config.maxPerPage,
  });

  commit(mutations.ADD_CUSTOMER_TICKET_HISTORY_PAGE, {
    id: id,
    items: res.data.items,
    page: page,
    nbPages: res.data.nbPages,
  });

  return res;
};

export const uploadTicket = async ({ commit }, { customerId }) => {
  const res = await api.ticket.upload();
  commit(mutations.ADD_CUSTOMER_TICKET, { customerId, ticket: res.data });

  return res;
};

export const createShareTicketRequest = async ({ commit }, id) => {
  const res = await api.ticket.shareRequest.create(id);
  commit(mutations.ADD_SHARE_TICKET_REQUEST, { id, request: res.data });

  return res;
};

export const getShareTicketRequestsPage = async (
  { commit },
  { id, page, criteria = {}, sorting = {} }
) => {
  const res = await api.ticket.shareRequest.all(id, {
    page,
    itemsPerPage: config.maxPerPage,
    criteria,
    sorting,
  });
  const count = res.data["hydra:totalItems"];
  commit(mutations.SET_SHARE_TICKET_REQUESTS_PAGE, {
    id,
    items: res.data["hydra:member"],
    page,
    nbPages: Math.ceil(count / config.maxPerPage),
    nbResults: res.data["hydra:totalItems"],
    maxPerPage: config.maxPerPage,
  });

  return res;
};

export const cancelShareTicketRequest = async ({ commit }, id) => {
  const res = await api.ticket.shareRequest.cancel(id);
  commit(mutations.ADD_SHARE_TICKET_REQUEST, res.data);

  return res;
};

export const sendShareTicketRequestReminder = async ({ commit }, id) => {
  const res = await api.ticket.shareRequest.sendReminder(id);
  commit(mutations.ADD_SHARE_TICKET_REQUEST, res.data);

  return res;
};

export const activateShareTicketRequest = async ({ commit }, { id, limit }) => {
  const res = await api.ticket.shareRequest.activate(id, limit);
  commit(mutations.ADD_SHARE_TICKET_REQUEST, res.data);

  return res;
};

export const rejectShareTicketRequest = async ({ commit }, id) => {
  const res = await api.ticket.shareRequest.reject(id);
  commit(mutations.ADD_SHARE_TICKET_REQUEST, res.data);

  return res;
};
